import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import "./addDepartment.css";
import CheckMark from "../../Assets/Icons/CheckMark.png";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateDepartment } from "../../modules/department/departmentThunk";
import { resetUpdateDepartment } from "../../modules/department/departmentSlice";

const EditSpeciality = forwardRef(({ department, isEdit, setSelectedView }, ref) => {
  const dispatch = useDispatch();
  const { updatedDepartment, updatedDepartmentError } = useSelector((state) => state.department);
  const { t } = useTranslation();
  const [selectedTimes, setSelectedTimes] = useState([]);
  const times = [20, 30, 45, 60, 90];
  useEffect(() => {
    if (updatedDepartmentError) {
      ToastPopup.error(updatedDepartmentError);
    }
    if (updatedDepartment && updatedDepartment.status === "success") {
      const depName = updatedDepartment.data.department.departmentName.en;
      setSelectedView("doctorSpecialization");
      ToastPopup.success(t("departmentUpdated", { depName }));
    }
    dispatch(resetUpdateDepartment());
  }, [updatedDepartment, updatedDepartmentError]);

  useImperativeHandle(ref, () => ({
    saveSpeciality,
  }));

  const saveSpeciality = () => {
    if (selectedTimes.length === 0) {
      ToastPopup.error(t("pleaseSelectOneTime"));
      return;
    }

    const previousTimes = department.duration.map((item) => item.timeInMinutes);

    const durationToBeAdded = selectedTimes.filter((time) => !previousTimes.includes(time));
    const durationToBeDeleted = previousTimes.filter((time) => !selectedTimes.includes(time)).map((time) => department.duration.find((d) => d.timeInMinutes === time)._id);

    if (durationToBeAdded.length > 0 || durationToBeDeleted.length > 0) {
      const updatedData = {
        durationToBeAdded,
        durationToBeDeleted,
      };

      const data = {
        departmentId: department._id,
        updatedData,
      };

      dispatch(updateDepartment(data));
    } else {
      ToastPopup.error(t("noChanges"));
    }
  };

  useEffect(() => {
    if (isEdit && department) {
      const times = department.duration.map((item) => item.timeInMinutes);
      setSelectedTimes(times);
    }
  }, [isEdit, department]);

  const handleTimeClick = (time) => {
    if (!department.isActive) {
      return;
    }
    if (department.departmentName.en.trim() === "") {
      return;
    }
    setSelectedTimes((prevTimes) => {
      const newTimes = prevTimes.includes(time) ? prevTimes.filter((t) => t !== time) : [...prevTimes, time];
      return newTimes;
    });
  };
  console.log(department);
  return (
    <div>
      <div className="department-add">
        <div className="input-div">
          <input type="text" className="department-add-input disabled" value={department?.departmentName?.en || ""} disabled={true} />
        </div>
        <div className="input-div">
          <input type="text" className="department-add-input disabled" value={department?.departmentName?.vi || ""} disabled={true} />
        </div>
      </div>
      <div className="speciality-head code seprate-speciality-head">
        <div className="bottom-div-dp">
          <div className="speciality-name">
            {t("departmentCode")}
            <span className="astrik">*</span>
          </div>
          <div className="input-div">
            <input type="text" className="department-add-input disabled" value={department.code} disabled={true} />
          </div>
        </div>
        <div className="bottom-div-dp">
          <div className="speciality-duration">
            {t("durationInMins")}
            <span className="astrik">*</span>
          </div>
          <div className="department-add-time time-duration-create">
            <div className="time-options">
              {times.map((time, index) => (
                <div key={index} className={`time-option ${selectedTimes.includes(time) ? "selected" : ""}`} onClick={() => handleTimeClick(time)}>
                  {time} {t("min")}
                  {selectedTimes.includes(time) && <img src={CheckMark} alt="Selected Icon" className="selected-icon" />}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default EditSpeciality;
